/*
  !IMPORTANT!: This file will be deleted in the future!
  If you want to use this functionality, please rather turn your *.vue file into a composition API and directly use the `useAbsenceList` composable instead.
  This file is only kept for backwards compatibility for old *.vue files that are still using options API and mixins.

  If you want to change the branding functionality, please do it in this mixin AND the composable!
*/
import Classbooks from 'src/api/classbooks.js'

const absenceList = {
  data: () => ({
    creating: {},
    toggleCreatingModal: false
  }),
  computed: {
    getCreating: {
      get () {
        return !!Object.keys(this.creating).length
      },

      set () {}
    }
  },
  methods: {
    async fetchAbsenceTypes (classbookId, entityId = this.userId, entityName = this.entityName) {
      if (!classbookId) return
      const { data } = await Classbooks.getAbsenceTypesByEntityNameEntityId(classbookId, entityName, entityId)
      return data
    },
    async fetchAbsenceCategories (classbookId) {
      if (!classbookId) return
      const { data } = await Classbooks.getAbsenceCategories(classbookId)
      return data
    },
    createAbsenceTemplate (userId = this.userId) {
      this.creating = {
        user_id: Number(userId),
        begins_at: this.entry?.begins_at,
        ends_at: this.entry?.ends_at,
        classbook_id: Number(this.$route.params.classbook)
      }
    },
    addAbsence (userId = this.userId) {
      this.createAbsenceTemplate(userId)
      this.toggleCreatingModal = true
    },
    resetCreating () {
      this.creating = {}
      this.toggleCreatingModal = false
    }
  }
}

export default absenceList
